import React from "react";
import { useField } from "formik";
import styled from "styled-components";
import RichTextEditor from "../RichTextEditor";
import FieldErrorMessage from "./FieldErrorMessage";
import FieldLabel from "./FieldLabel";

const RichTextField = (props: Props) => {
  const { label, name, id, hiddenLabel } = props;
  const [field, meta, { setValue }] = useField(props);

  const showError = Boolean(meta.touched && meta.error);
  const htmlFor = id || name;

  const handleChange = (value: string) => {
    if (value === '<p class="slate-p"></p>') {
      setValue(null);
    } else {
      setValue(value);
    }
  };

  return (
    <FieldWrapper>
      <FieldLabel htmlFor={htmlFor} visuallyHidden={hiddenLabel}>
        {label}
      </FieldLabel>
      <RichTextEditor
        {...field}
        id={htmlFor}
        name={name}
        error={showError}
        onChange={handleChange}
      />
      <FieldErrorMessage name={name} />
    </FieldWrapper>
  );
};

type Props = {
  label: string;
  name: string;
  id?: string;
  placeholder?: string;
  hiddenLabel?: boolean;
};

const FieldWrapper = styled.div`
  margin-bottom: 1.5rem;
`;

export default RichTextField;
